import { MultiSelectOption, RescheduleReason } from '@dispatch/shared/types';
import { v4 as uuidv4 } from 'uuid';
import { dispatchClient } from '../clients';

const APIM_SERVICE_RESCHEDULE_REASONS_URL = (tenantId: string) =>
  `configuration/${tenantId}/reschedule-reasons`;

export async function getRescheduleReasons(
  tenantId: string
): Promise<MultiSelectOption[] | undefined> {
  try {
    const response = await dispatchClient.get<RescheduleReason[]>(
      `${APIM_SERVICE_RESCHEDULE_REASONS_URL(tenantId)}`,
      {
        headers: {
          'Request-ID': uuidv4(),
        },
      }
    );

    const reasons: RescheduleReason[] = response?.data;
    const reasonOptions: MultiSelectOption[] = reasons.map(
      (reason: RescheduleReason) => {
        return {
          title: reason.name,
          value: reason.id,
        };
      }
    );

    if (response.status === 200 && reasonOptions) {
      return reasonOptions;
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.error('error fetching reschedule-reasons from API', e);
  }
  return undefined;
}
